// Generat automat din README.md - Platformă E-learning pentru dezvoltarea profesională a lui Margarit Alexandru Florian
import React, { useState } from 'react';
import { BookOpen, PlayCircle, Award, Clock, Users, TrendingUp, Plus, Search, Filter, Star, CheckCircle, BarChart3, Download, User, Target, Coffee } from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const PlatformaElearning = () => {
  const [showCourseModal, setShowCourseModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [filterCategory, setFilterCategory] = useState('Toate');
  const [searchTerm, setSearchTerm] = useState('');

  // Cursuri pentru dezvoltarea profesională a lui Margarit Alexandru Florian - proprietar Botez de poveste
  const elearningData = {
    overview: {
      totalCourses: 12,
      completedCourses: 8,
      inProgressCourses: 3,
      certificatesEarned: 5
    },
    courses: [
      {
        id: 1,
        title: 'Design Avansat pentru Torturi de Botez',
        category: 'Specialitate Culinară',
        instructor: 'Chef Raluca Mănescu',
        duration: '8 ore',
        level: 'Intermediar',
        progress: 100,
        rating: 4.9,
        status: 'Finalizat',
        completedDate: '2024-02-20',
        description: 'Tehnici avansate de decorare torturi pentru evenimente speciale',
        modules: 10,
        price: '350 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Design Torturi', 'Decorațiuni', 'Tehnici Avansate'],
        thumbnail: 'cake-design.jpg',
        lastUpdated: '2024-01-15',
        certificateEarned: true,
        skillsGained: ['Design floral', 'Tehnici fondant', 'Modelarea figurinelor']
      },
      {
        id: 2,
        title: 'Managementul Afacerilor Mici',
        category: 'Management',
        instructor: 'Prof. Alexandru Ionescu',
        duration: '12 ore',
        level: 'Intermediar',
        progress: 85,
        rating: 4.7,
        status: 'În progres',
        description: 'Strategii de dezvoltare și management pentru afacerile mici',
        modules: 15,
        price: '450 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Antreprenoriat', 'Strategie', 'Finanțe'],
        thumbnail: 'business-management.jpg',
        lastUpdated: '2024-03-01',
        certificateEarned: false,
        skillsGained: ['Planificare strategică', 'Analiza costurilor', 'Marketing local']
      },
      {
        id: 3,
        title: 'Siguranța Alimentelor și HACCP',
        category: 'Siguranță și Conformitate',
        instructor: 'Dr. Maria Popescu',
        duration: '6 ore',
        level: 'Începător',
        progress: 100,
        rating: 4.8,
        status: 'Finalizat',
        completedDate: '2023-04-15',
        description: 'Principiile HACCP și siguranța alimentelor în producția artizanală',
        modules: 8,
        price: '280 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['HACCP', 'Siguranța alimentelor', 'Conformitate'],
        thumbnail: 'food-safety.jpg',
        lastUpdated: '2023-04-01',
        certificateEarned: true,
        skillsGained: ['Implementare HACCP', 'Control calitate', 'Conformitate legală']
      },
      {
        id: 4,
        title: 'Marketing Digital pentru Afaceri Locale',
        category: 'Marketing',
        instructor: 'Specialist Mihai Dumitrescu',
        duration: '10 ore',
        level: 'Începător',
        progress: 100,
        rating: 4.6,
        status: 'Finalizat',
        completedDate: '2024-01-10',
        description: 'Strategii de marketing online pentru promovarea afacerilor locale',
        modules: 12,
        price: '320 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Marketing Digital', 'Social Media', 'SEO Local'],
        thumbnail: 'digital-marketing.jpg',
        lastUpdated: '2023-12-15',
        certificateEarned: true,
        skillsGained: ['Facebook Ads', 'Google Business', 'Content Marketing']
      },
      {
        id: 5,
        title: 'Fotografie Profesională pentru Produse',
        category: 'Creative & Media',
        instructor: 'Fotograf Elena Radu',
        duration: '5 ore',
        level: 'Începător',
        progress: 65,
        rating: 4.5,
        status: 'În progres',
        description: 'Tehnici de fotografiere produse pentru prezentare online',
        modules: 7,
        price: '250 RON',
        language: 'Română',
        hasQuiz: false,
        hasCertificate: true,
        tags: ['Fotografie', 'Produse', 'Lighting'],
        thumbnail: 'product-photography.jpg',
        lastUpdated: '2024-02-01',
        certificateEarned: false,
        skillsGained: ['Compoziție foto', 'Iluminat natural', 'Editing de bază']
      },
      {
        id: 6,
        title: 'Excel pentru Afaceri - Nivel Avansat',
        category: 'Tehnologie',
        instructor: 'Expert IT Claudiu Stefanescu',
        duration: '8 ore',
        level: 'Avansat',
        progress: 40,
        rating: 4.4,
        status: 'În progres',
        description: 'Funcții avansate Excel pentru gestionarea afacerii și raportare',
        modules: 9,
        price: '380 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Excel', 'Analiza datelor', 'Automatizare'],
        thumbnail: 'excel-advanced.jpg',
        lastUpdated: '2024-03-10',
        certificateEarned: false,
        skillsGained: ['Macros', 'Pivot Tables', 'Analiza financiară']
      },
      {
        id: 7,
        title: 'Contabilitate pentru Micro-întreprinderi',
        category: 'Finanțe',
        instructor: 'Contabil Cristina Popescu',
        duration: '15 ore',
        level: 'Intermediar',
        progress: 100,
        rating: 4.7,
        status: 'Finalizat',
        completedDate: '2023-06-30',
        description: 'Principiile contabilității pentru afacerile mici și micro-întreprinderi',
        modules: 18,
        price: '500 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Contabilitate', 'Fiscalitate', 'Declarații'],
        thumbnail: 'accounting.jpg',
        lastUpdated: '2023-06-01',
        certificateEarned: true,
        skillsGained: ['Gestiune financiară', 'Declarații fiscale', 'Buget']
      },
      {
        id: 8,
        title: 'Serviciul Clienți de Excelență',
        category: 'Relații cu Clienții',
        instructor: 'Specialist Laura Mihăilă',
        duration: '6 ore',
        level: 'Începător',
        progress: 100,
        rating: 4.6,
        status: 'Finalizat',
        completedDate: '2024-03-05',
        description: 'Tehnici pentru oferirea unui serviciu clientului de calitate superioară',
        modules: 8,
        price: '200 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Customer Service', 'Comunicare', 'Satisfacția clientului'],
        thumbnail: 'customer-service.jpg',
        lastUpdated: '2024-02-20',
        certificateEarned: true,
        skillsGained: ['Comunicare eficientă', 'Rezolvare conflicte', 'Fidelizare']
      }
    ]
  };

  // Filtrarea cursurilor
  const filteredCourses = elearningData.courses.filter(course => {
    const matchesSearch = course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         course.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = filterCategory === 'Toate' || course.category === filterCategory;
    return matchesSearch && matchesCategory;
  });

  const categories = ['Toate', ...new Set(elearningData.courses.map(course => course.category))];

  const handleViewCourse = (course) => {
    setSelectedCourse(course);
    setShowCourseModal(true);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Finalizat': return 'success';
      case 'În progres': return 'info';
      case 'Planificat': return 'warning';
      default: return 'default';
    }
  };

  const columns = [
    {
      header: 'Curs',
      key: 'title',
      render: (value, row) => (
        <div>
          <p className="font-semibold text-gray-900 dark:text-white">{value}</p>
          <p className="text-sm text-gray-500">{row.category}</p>
        </div>
      )
    },
    {
      header: 'Instructor',
      key: 'instructor'
    },
    {
      header: 'Durată',
      key: 'duration'
    },
    {
      header: 'Progress',
      key: 'progress',
      render: (value, row) => (
        <div className="flex items-center space-x-2">
          <div className="flex-1 bg-gray-200 rounded-full h-2">
            <div 
              className="bg-blue-600 h-2 rounded-full" 
              style={{ width: `${value}%` }}
            ></div>
          </div>
          <span className="text-sm font-medium">{value}%</span>
        </div>
      )
    },
    {
      header: 'Status',
      key: 'status',
      render: (value) => (
        <Badge variant={getStatusColor(value)}>{value}</Badge>
      )
    },
    {
      header: 'Rating',
      key: 'rating',
      render: (value) => (
        <div className="flex items-center space-x-1">
          <Star className="w-4 h-4 text-yellow-500 fill-current" />
          <span>{value}</span>
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-3">
            <BookOpen className="w-8 h-8 text-blue-500" />
            Platformă E-learning - Margarit Alexandru Florian
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Dezvoltare profesională continuă pentru proprietarul "Botez de poveste"
          </p>
        </div>
      </div>

      {/* Statistici învățare */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card title="Cursuri Totale" icon={BookOpen} variant="stats">
          <div className="text-3xl font-bold text-blue-600">
            {elearningData.overview.totalCourses}
          </div>
          <p className="text-sm text-gray-500 mt-1">Cursuri disponibile</p>
        </Card>

        <Card title="Cursuri Finalizate" icon={CheckCircle} variant="stats">
          <div className="text-3xl font-bold text-green-600">
            {elearningData.overview.completedCourses}
          </div>
          <p className="text-sm text-gray-500 mt-1">Cu succes</p>
        </Card>

        <Card title="În Progres" icon={Clock} variant="stats">
          <div className="text-3xl font-bold text-yellow-600">
            {elearningData.overview.inProgressCourses}
          </div>
          <p className="text-sm text-gray-500 mt-1">Cursuri active</p>
        </Card>

        <Card title="Certificate Obținute" icon={Award} variant="stats">
          <div className="text-3xl font-bold text-purple-600">
            {elearningData.overview.certificatesEarned}
          </div>
          <p className="text-sm text-gray-500 mt-1">Certificări profesionale</p>
        </Card>
      </div>

      {/* Info despre dezvoltarea profesională */}
      <Card>
        <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-4">
          <div className="flex items-start">
            <User className="w-5 h-5 text-purple-500 mt-0.5 mr-3" />
            <div>
              <h3 className="text-sm font-medium text-purple-800 dark:text-purple-200">
                Dezvoltare Profesională Continuă
              </h3>
              <p className="mt-2 text-sm text-purple-700 dark:text-purple-300">
                <strong>Margarit Alexandru Florian</strong> investește în dezvoltarea profesională pentru 
                a-și îmbunătăți continuu competențele în design torturi, management afacerii, marketing digital 
                și toate aspectele necesare pentru succesul "Botez de poveste". Fiecare curs completat contribuie 
                la oferirea de servicii de calitate superioară clienților.
              </p>
            </div>
          </div>
        </div>
      </Card>

      {/* Căutare și filtrare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
              type="text"
              placeholder="Caută cursuri după nume sau descriere..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            />
          </div>
          
          <select
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          >
            {categories.map(category => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
        </div>
      </Card>

      {/* Tabel cursuri */}
      <Card title={`Cursurile lui Margarit Alexandru Florian (${filteredCourses.length})`}>
        <Table 
          columns={columns} 
          data={filteredCourses}
          onRowClick={handleViewCourse}
        />
      </Card>

      {/* Modal detalii curs */}
      <Modal
        isOpen={showCourseModal}
        onClose={() => setShowCourseModal(false)}
        title={`Detalii Curs - ${selectedCourse?.title}`}
        size="xl"
      >
        {selectedCourse && (
          <div className="space-y-6">
            {/* Header curs */}
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 p-6 rounded-lg">
              <div className="flex items-start justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white">
                    <BookOpen className="w-8 h-8" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                      {selectedCourse.title}
                    </h3>
                    <p className="text-gray-600 dark:text-gray-300">
                      {selectedCourse.instructor}
                    </p>
                    <div className="flex items-center space-x-2 mt-2">
                      <Badge variant="info">{selectedCourse.category}</Badge>
                      <Badge variant={getStatusColor(selectedCourse.status)}>
                        {selectedCourse.status}
                      </Badge>
                      {selectedCourse.certificateEarned && (
                        <Badge variant="success">Certificat obținut</Badge>
                      )}
                    </div>
                  </div>
                </div>
                
                <div className="text-right">
                  <div className="text-3xl font-bold text-blue-600 mb-1">
                    {selectedCourse.progress}%
                  </div>
                  <div className="flex items-center space-x-1">
                    <Star className="w-4 h-4 text-yellow-500 fill-current" />
                    <span className="text-sm">{selectedCourse.rating}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Informații curs */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <h4 className="font-semibold text-gray-900 dark:text-white">Informații Generale</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Durată:</span>
                    <span>{selectedCourse.duration}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Nivel:</span>
                    <span>{selectedCourse.level}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Module:</span>
                    <span>{selectedCourse.modules}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Preț plătit:</span>
                    <span className="font-medium text-green-600">{selectedCourse.price}</span>
                  </div>
                  {selectedCourse.completedDate && (
                    <div className="flex justify-between">
                      <span className="text-gray-500">Finalizat la:</span>
                      <span>{selectedCourse.completedDate}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="space-y-4">
                <h4 className="font-semibold text-gray-900 dark:text-white">Competențe Dobândite</h4>
                <div className="space-y-2">
                  {selectedCourse.skillsGained?.map((skill, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <CheckCircle className="w-4 h-4 text-green-500" />
                      <span className="text-sm text-gray-600 dark:text-gray-400">{skill}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Descrierea cursului */}
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-2">Descriere</h4>
              <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                {selectedCourse.description}
              </p>
            </div>

            {/* Tags */}
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-2">Tag-uri</h4>
              <div className="flex flex-wrap gap-2">
                {selectedCourse.tags?.map((tag, index) => (
                  <span 
                    key={index}
                    className="px-3 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full text-xs"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end space-x-3 pt-4 border-t">
              {selectedCourse.status === 'În progres' && (
                <button className="btn-primary flex items-center gap-2">
                  <PlayCircle className="w-4 h-4" />
                  Continuă Cursul
                </button>
              )}
              {selectedCourse.certificateEarned && (
                <button className="btn-secondary flex items-center gap-2">
                  <Download className="w-4 h-4" />
                  Descarcă Certificat
                </button>
              )}
              <button
                onClick={() => setShowCourseModal(false)}
                className="btn-secondary"
              >
                Închide
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default PlatformaElearning;